<template>
  <div class="main-content">
    <!-- Toolbar -->
    <v-app-bar color="red" dark outlined app>
      <v-btn icon @click="$router.go(-1)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>Laporan</v-toolbar-title>
    </v-app-bar>

    <v-main>
      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="date"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }" class="ma-3">
          <v-text-field
            v-model="date"
            label="Tanggal Laporan"
            prepend-icon="event"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="date" scrollable :max="today" color="red">
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="modal = false">Kembali</v-btn>
          <v-btn text color="red" @click="$refs.dialog.save(date)">Pilih</v-btn>
        </v-date-picker>
      </v-dialog>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Menu</th>
              <th class="text-left">Penjualan</th>
              <th class="text-left">Total</th>
            </tr>
          </thead>

          <!-- Skeleton -->
          <tbody v-if="isLoading">
            <tr>
              <td colspan="3">
                <v-skeleton-loader
                  class="mx-auto"
                  type="list-item"
                  v-for="i in 3"
                  :key="i"
                ></v-skeleton-loader>
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr v-for="item in summary" :key="item.name">
              <td>{{ item.name }}</td>
              <td>{{ item.amount }}</td>
              <td>
                {{
                  (item.amount * item.price).toLocaleString("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
                }}
              </td>
            </tr>
            <tr>
              <td colspan="2">Total</td>
              <td>
                {{
                  totalTransaction.toLocaleString("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
                }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-main>
  </div>
</template>

<script>
import store from "@/store";
import common from "@/mixins/common";
import EzKasirAPI from "@/library/api";

export default {
  name: "Report",
  mixins: [common],
  data() {
    return {
      user: store.state.user,
      storeId: this.$route.params.id,
      summary: [],
      totalTransaction: 0,
      date: new Date().toISOString().substr(0, 10),
      modal: false,
      isLoading: true,
    };
  },
  methods: {
    loadSummary() {
      this.isLoading = true;
      let tempDate = this.date.replace(/-/g, "");
      const url = `${process.env.VUE_APP_API_URL}/store/report/summary/${this.storeId}?date=${tempDate}`;
      EzKasirAPI.get(url)
        .then((response) => {
          this.summary = response.data.data.summary;
          this.totalTransaction = response.data.data.total;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    this.loadSummary();
  },
  computed: {
    today() {
      return new Date().toISOString().substr(0, 10);
    },
  },
  watch: {
    modal(val) {
      if (!val) {
        this.loadSummary();
      }
    },
  },
};
</script>

<style scoped>
.main-content {
  padding-top: 15px;
}
</style>